import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { Helmet } from 'react-helmet';

import { history } from 'store/ConfigureStore';
import { seguridadCargandoSelector } from 'store/selectors';

import ButtonSection from 'components/ButtonSection';
import CardSmall from 'components/CardSmall';
import { showExternalHeader, updateAriaLiveMessage } from 'actions/ui';
import { approveEmailChange } from 'actions/seguridad';
import { CHANGE_EMAIL_APPROVE_TITLE } from 'constants/pageTitles';
import {
  HACIENDO_CLICK_TEXT,
  CONFIRMAR_CORREO_TEXT,
  ULTIMO_PASO_TEXT,
} from 'constants/commonConstants';

const CambioEmailApproveContainer = () => {
  const [state, setState] = useState({});
  const dispatch = useDispatch();
  const cargando = useSelector(seguridadCargandoSelector);

  useEffect(() => {
    const { uuid, email } = queryString.parse(history.location.search);
    setState({ email: window.atob(email), uuid });
    dispatch(showExternalHeader());
    dispatch(updateAriaLiveMessage(CHANGE_EMAIL_APPROVE_TITLE));
  }, [history]);

  const handleClickAccept = () => {
    dispatch(approveEmailChange(state.uuid));
  };

  return (
    <>
      <Helmet title={CHANGE_EMAIL_APPROVE_TITLE} />
      <CardSmall title={ULTIMO_PASO_TEXT}>
        <p>{HACIENDO_CLICK_TEXT}</p>
        <ButtonSection
          idPrimary="change-email-submit-button"
          textPrimary={CONFIRMAR_CORREO_TEXT}
          handleClickPrimary={handleClickAccept}
          isLoadingPrimary={cargando}
        />
      </CardSmall>
    </>
  );
};

export default CambioEmailApproveContainer;
